import Nullstack from 'nullstack';
export default function IconCactusOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-cactus-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 9v1a3 3 0 0 0 3 3h1"
  }), "   ", Nullstack.element("path", {
    d: "M18 8v5a3 3 0 0 1 -.129 .872m-2.014 2.004a3 3 0 0 1 -.857 .124h-1"
  }), "   ", Nullstack.element("path", {
    d: "M10 21v-11m0 -4v-1a2 2 0 1 1 4 0v5m0 4v7"
  }), "   ", Nullstack.element("path", {
    d: "M7 21h10"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}